import { getProvidersOfCompanyApi } from 'api/companies';
import { getAllCustom } from 'redux/crudCreatorCustom/actions';

export const MODEL_NAME = 'providersOfCompany';

export const getProvidersOfCompany = getAllCustom(
  MODEL_NAME,
  getProvidersOfCompanyApi,
);
